import { Typography, Link } from '@mui/material'
import React from 'react'

export function Copyright() {
    return (
        <div className='relative'>
            <Typography
                className="mt-4 text-center"
                variant="body2"
                color="text.secondary"
                align="center"
            >
                {'Copyright © '}
                <Link
                    className="mr-1"
                    color="inherit"
                    href="https://fitme.jobs"
                >
                    Fitme.jobs
                </Link>
                {new Date().getFullYear()}
                {'.'}
            </Typography>
            <Typography
                className="mt-2 text-center text-xs"
                variant="body2"
                color="text.secondary"
                align="center"
            >
                ({process.env.REACT_APP_BUILD_VERSION ?? 'LOCAL'}) {process.env.REACT_APP_APP_VERSION ?? '0.0.0'}
            </Typography>
        </div>
    )
}
